import logoSrc from '../../../assets/logo.svg';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <a href="#top" className={styles.brand}>
            <img src={logoSrc} alt="mediLawyer" className={styles.logoImg} />
          </a>
          <div className={styles.sub}>법무법인 오킴스 의료팀 공식 서비스</div>
        </div>
        <div className={styles.copy}>© 2025 법무법인 오킴스. All rights reserved.</div>
      </div>
    </footer>
  );
}
